import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import { BasicSelect} from 'vue-search-select';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import DatePicker from 'vue2-datepicker'
import user_tracker from '../../../../usertracker'
import {
  buildConnectionsSearchPayload,
  CONNECTION_SEARCH_PURPOSE,
  getConnectionsSearchUrl
} from '../../../../utils/connectionsSearchApi.js';

export default {
  name: 'un-scheduled-list',
  components: {
    BasicSelect,
    Multiselect,
    Paginate,
    VueElementLoading,
    DatePicker
  },
  props: [],
  data() {
    return {
      pageCountrule: 0,
      pageCount: 0,
      pageNo: 0,
      isLoading: false,
      schduleLoading: false,
      unschedulesList: [],
      username: '',
      useremail: '',
      uasertype: '',
      hubid: '',
      showModal: false,
      showReplaceVehicleModal: false,
      scheduleData: '',
      hubdata: '',
      vehicleitem: {
        id: '',
        text: '',
        IsGPSEnabled: ''
      },
      oldVehicleNo: '',
      vehcileListArr: [],
      replacementReason: '',
      vehicleNumber: '',
      vehicleListData: {},
      reasonListArr: [],
      vehicleLoading: '',
      showreplacementReasonErr: '',
      showvehicleNumberErr: '',
      //for filter unschedule list
      vendornamelist: [],
      vendornameitem: {
        value: '',
        text: ''
      },
      vendorname: '',
      vendornameLoading: '',
      vehiclenolist: [],
      vehiclenoitem: {
        value: '',
        text: ''
      },
      vehicleno: '',
      vehiclenoLoading: '',
      fromdate: '',
      todate: '',

      //for schedule local trip
      LocalTripModal: false,
      tripsheetno: '',
      tripsheetnodate: '',
      routetypeerror: '',
      routelist: [],
      routeitem: {
        value: '',
        text: '',
        actualroute: '',
        isBikerAllowed:''
      },
      route: '',
      RouteError: '',
      RouteLoading: '',
      actualroute: '',
      triptypelist: [{
        value: 'local',
        text: 'Local Vendor Based'
      }, {
        value: 'market',
        text: 'Market Hired'
      }],
      triptypeitem: {
        value: '',
        text: ''
      },
      triptype: '',
      triptypevalue:'',
      localvendorlist: [],
      localvendoritem: {
        value: '',
        text: ''
      },
      localvendor: '',
      LocalVendorLoading: '',
      localvehiclenolist: [],
      localvehiclenoitem: {
        value: '',
        text: ''
      },
      localvehicleno: '',
      LocalVehicleNoLoading: '',
      openkm: '',
      drivername: '',
      drivercontactno: '',
      amount: '',
      reasonlist: [{
        value: 1,
        text: "Extra load"
      }, {
        value: 2,
        text: "Vendor not available"
      }, {
        value: 3,
        text: "Branch vehicle vendor not allocated"
      }],
      reasonitem: {
        value: '',
        text: ''
      },
      reason: '',
      VehicleDetails: [],
      VehicleError: '',
      TripConnectionScheduleResult: {},
      scheduleDeatilsList: [],
      cutofflist: [],
      cutoffitem: {
        value: '',
        text: '',
        name: '',
        date:''
      },
      cutoff: '',
      CutoffError: '',
      IsCutOffPresent: false,
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      //for linehaulbiker
      trip: "networklocal",
      tripErr: "",
      bikervehiclelist: [],
      bikervehicleitem: {
        value: '',
        text: '',
        vehicleid: ''
      },
      bikervehiclenumber: '',
      BikerVehicleNumberLoading: '',
      bikerlist: [],
      bikeritem: {
        value: '',
        text: '',
        mobileno: '',
        vehicleno: ''
      },
      bikername: '',
      BikerNameLoading: '',
      validVehicleNoError: false,
      userData:[],
      stateListData:[],
      triptypevalue:'',
      vehicletype:'',
      vehicletypeitem: {
        value: '',
        text: ''
      },
      vehicletypelist:[],
      vehicletypeloader:'',
      marketvendorname:'',
      bikertrip:false,
      isBikerFlag:false,
      isBikerTripEnabled:false,
      srListForAllocatedParentCity:[],
      srlistitem: {
				value:'',
				text:'',
        name:''
      },
      
			srId :'',
			srName :'',
      parentcityId:0,
      parentcityName:'',
      hubIdList:[],
      srListForAllocatedParentCity:[],
      srErr:'',
      sr:'',
      vehicleType:'',
      hubIdList : [],
      isVTRAFlag : false,
      isAdhocEnable:false,
      adhocvendorlist: [],
      adhocvendoritem: {
        value: '',
        text: ''
      },
      adhocvendor: '',
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userData = userdetail;
    this.uasertype = userdetail[0].utype;
    this.username = userdetail[0].FirstName;
    this.useremail = userdetail[0].email
    this.hubid = userdetail[0].HubId;
    user_tracker.checkUserIP(userdetail[0], "UnScheduledList", this.$route.path);
    this.fromdate = new Date()
    this.todate = new Date()
    this.getHubDetails();
    this.getVendorName();
    this.getVehicleNo();
    this.getUnscheduledList();
    if (this.trip != '') {
      this.getConnections(4);
    }
    const anchor = this.$router.currentRoute.hash;
    this.$nextTick(() => {
      if (anchor && document.querySelector(anchor)) {
        location.href = anchor;
      }
    });
    this.stateListData = window.localStorage.getItem('stateCodeList') ? window.localStorage.getItem('stateCodeList') : [];
  },
  methods: {
    getHubDetails() {
      this.input = {
        hubids: this.hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubdata = result.data.ResponseData[0];
            this.parentcityId = this.hubdata.ParentCityID;
            this.parentcityName = this.hubdata.ParentCityName;
          } else {
            this.hubcode = '';
          }
        }, error => {
          console.error(error)
        })
    },


    selectSr(srListitem) {
			this.srlistitem = srListitem;
			this.srId = this.srlistitem.value;
			this.srName = this.srlistitem.name;
    
		},


    getHubsAgainstParentCity(){
      this.input = {
        ParentCityID: [this.parentcityId]
      }
      this.hubIdList= []
      this.isLoading = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'getSVCMappedAgainstParentCity_master', 
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            const hubdata = result.data.ResponseData.svcData;
            
            hubdata.forEach(element => {
              this.hubIdList.push(element.HubID);
            });
           
            
            this.getSRListAgainstSVCs();

          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })

    },


    getSRListAgainstSVCs(){
      this.input = {
        userType: "3",
        hubids:this.hubIdList
      }

      this.srListForAllocatedParentCity =[]

      axios({
        'method': 'POST',
        'url': apiUrl.api_url_hubops + 'getSRListAgainstSVCs',
        'data': this.input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {
          const srData = result.data.ResponseData.srDetails;
            
          for (let i = 0 ; i < srData.length ; i++){
            this.srListForAllocatedParentCity.push({
              value: srData[i].OldDeliveryUserOrUserId,
              text :srData[i].FirstName + srData[i].LastName +' (' + srData[i].OldDeliveryUserOrUserId+ ')',
              name: srData[i].FirstName + srData[i].LastName
            });
            
            }

          

        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }

      }, error => {
        console.error(error)
      })


    },

    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    showMdl(data) {
      this.scheduleData = data;
      this.showModal = true;
    },
    scheduleVehicle() {
      this.schduleLoading = true;
      this.input = ({
        "currentHubId": this.scheduleData.currenthub.hubid,
        "placementId": this.scheduleData.placementid,
        "connectionName": this.scheduleData.connectionname,
        "fullConnectionName": this.scheduleData.fullconnectionname,
        "vehicleNo": this.scheduleData.vehicleno,
        "connectionId": this.scheduleData.connectionid,
        "vendorId": this.scheduleData.vehiclevendorid,
        "vendorName": this.scheduleData.vendorname,
        "hubCode": this.hubdata.HubCode,
        "hubName": this.scheduleData.currenthub.hubname,
        "driverDetails": [{
          "DriverName": this.scheduleData.drivername,
          "Mobile": this.scheduleData.driverphone
        }],
        "createdBy": this.useremail,
        "connectionType": 0
      })
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'tripConnectionScheduleMaster',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.schduleLoading = false;
          
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.$alertify.success(result.data.ReturnMessage);
            this.closeModal();
            this.getUnscheduledList();
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.unschedulesList = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
          
          user_tracker.checkUserIP(this.userData[0], "Schedule Network Trip", this.$route.path,this.input)

        }, error => {
          console.error(error)
          this.schduleLoading = false;
        })
    },
    showReplaceVehicle(data) {
      this.oldVehicleNo = data.vehicleno
      this.vehicleListData = data;
      this.showReplaceVehicleModal = true;
      this.getVehicleList();
      this.getReasonList();
    },

    enabledBikerCondtion(){

      if(this.bikertrip){
        this.isBikerTripEnabled = true;
        this.getHubsAgainstParentCity();
        if(this.isBikerTripEnabled){
            this.vehicleType ='Biker';
            
        }
      }else{
        this.isBikerTripEnabled = false;
      }

      this.triptypeitem = {
        value: '',
        text: ''
      };
      this.triptype = '';
      this.localvendoritem = {
        value: '',
        text: ''
      }
      this.localvendor = ''
      this.LocalVendorLoading = ''
      this.cutofflist = []
      this.cutoffitem = {
        value: '',
        text: '',
        name: '',
        date:''
      }
      this.cutoff = ''
      this.CutoffError = ''
      this.IsCutOffPresent = false
      this.$validator.reset()
      if(this.isBikerTripEnabled){
      this.getCutOffList()
      }
      


    },

    getReasonList() {
      this.input = {
        Type: "placement"
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getVehicleReplacementReasons',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.reasonListArr = result.data.ResponseData
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }

        }, error => {
          console.error(error)
        })
    },
    getVehicleList() {
      this.vehicleLoading = 'Loading Vehicles...'
      this.input = {
        vendorid: this.vehicleListData.vendorid,
        vehicleid: this.vehicleListData.vehicleid
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'vehilceListReplaceInUnschedule',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          var vehicleData = [];
          this.vehicleLoading = ''
          if (result.data.ResultCode == 100) {
            this.vehcileListArr = result.data.ResponseData
            for (var i = 0; i < this.vehcileListArr.length; i++) {
              vehicleData.push({
                "id": this.vehcileListArr[i].VehicleNumber,
                "text": this.vehcileListArr[i].VehicleNumber,
                "IsGPSEnabled": this.vehcileListArr[i].IsGPSEnabled,
              })
            }
            this.vehcileListArr = vehicleData;
          }
        }, error => {
          this.vehicleLoading = ''
          console.error(error)
        })
    },
    SelectVehicle(vehicleitem) {
      this.vehicleitem = vehicleitem;
      this.vehicleNumber = this.vehicleitem.id;
      // var a = this.vehicleitem.id
      if (this.vehicleNumber) {
        this.showvehicleNumberErr = ""
      }
    },
    checkErr() {
      if (this.replacementReason) {
        this.showreplacementReasonErr = ""
      }
    },
    replaceVehicle() {
      if (this.replacementReason == '' || this.replacementReason == undefined || this.replacementReason == null) {
        this.showreplacementReasonErr = "Please select reason"
      }
      if (this.vehicleNumber == '' || this.vehicleNumber == undefined || this.vehicleNumber == null) {
        this.showvehicleNumberErr = "Please select vehicle"
      }
      if (this.vehicleitem.id == '' || this.replacementReason == '') {
        return false;
      }
      this.input = {
        "ReplacedVehicleNumber": this.oldVehicleNo,
        "ReplacementVehicleNumber": this.vehicleitem.id,
        "ReplacementReason": this.replacementReason,
        "PlacementID": this.vehicleListData.placementid,
        "GPSEnabled": this.vehicleitem.IsGPSEnabled
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'replacePlacedVehicle',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
            this.getUnscheduledList();
            this.closeReplaceVehicleModal();
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }

        }, error => {
          console.error(error)
        })
    },
    closeModal() {
      this.showModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    closeReplaceVehicleModal() {
      this.vehicleLoading = '';
      this.oldVehicleNo = '';
      this.vehicleNumber = "";
      this.replacementReason = "";
      this.reasonListArr = [];
      this.vehicleitem = {
        id: '',
        text: '',
        IsGPSEnabled: ''
      };
      this.showvehicleNumberErr = "";
      this.showreplacementReasonErr = "";
      this.showReplaceVehicleModal = false;

      // this.vehcileListArr = [];
      // this.$validator.reset();
      // this.errors.clear();

    },
    onSubmit: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pageNo = 0
        } else {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    //for filter schedule list
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD HH:MM:SS');
    },
    getUnscheduledList() {
      this.isLoading = true;
      this.input = ({
        "hubId": this.hubid[0]
      })
      if (this.fromdate != "" && this.fromdate != null) {
        this.input.fromDate = moment(this.fromdate).format('YYYY-MM-DD');
      }
      if (this.todate != "" && this.todate != null) {
        this.input.toDate = moment(this.todate).add(1, 'days').format('YYYY-MM-DD');
      }
      if (this.vendornameitem.text != "" && this.vendornameitem.text != null) {
        this.input.vendorName = this.vendornameitem.text;
      }
      if (this.adhocvendoritem.text != "" && this.adhocvendoritem.text != null) {
        this.input.vendorName = this.adhocvendoritem.text;
      }
      if (this.vehiclenoitem.text != "" && this.vehiclenoitem.text != null) {
        this.input.vehicleNo = this.vehiclenoitem.text;
      }
       if(this.isAdhocEnable && this.localvehicleno != '' && this.localvehicleno != null){  
      this.input.vehicleNo = this.localvehicleno;
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'getUnScheduledVehicle',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.isLoading = false;
            this.unschedulesList = result.data.ResponseData;
          } else if (result.data.ResultCode == 401) {
            this.isLoading = false;
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.isLoading = false;
            this.invalidTokenModal = false
            this.unschedulesList = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
          this.isLoading = false;

        })
    },
    getVehicleNo() {
      this.vehiclenoLoading = 'Loading Vehicle...'
      var VehicleNoData = []
      this.input = {};
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getNetworkScanVehicleList?currentHubId=' + this.hubid[0],
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.vehiclenoLoading = '';
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            VehicleNoData = result.data.ResponseData
            for (var i = 0; i < VehicleNoData.length; i++) {
              this.vehiclenolist.push({
                value: VehicleNoData[i].tripid,
                text: VehicleNoData[i].vehicleno
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            VehicleNoData = []
            this.vehiclenolist = []
            //this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          console.error(error)
        })
    },
    selectedVehicleNo(vehiclenoitem) {
      this.vehiclenoitem = vehiclenoitem
      this.vehicleno = vehiclenoitem.text
    },
    getVendorName() {
      this.vendornameLoading = 'Loading Vendor...'
      this.input = {
        "IsActive": 1,
        "VendorType": "network",
        "HubID": this.hubid[0]
      };
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'findVendorForTypeAllocation',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.vendornameLoading = '';
          if (result.data.ResultCode == 100) {
            var VendorNameData = result.data.ResponseData
            for (var i = 0; i < VendorNameData.length; i++) {
              this.vendornamelist.push({
                value: VendorNameData[i].vehicleVendorID,
                text: VendorNameData[i].VehicleVendorCompanyName + ' (' + VendorNameData[i].vehicleVendorID + ')'
              })
            }
          }
        }, error => {
          this.vendornameLoading = '';
          console.error(error)
        })
    },
    selectedVendor(vendornameitem) {
      this.vendornameitem = vendornameitem
      this.vendorname = vendornameitem.text
    },
    resetflt() {
      this.schedulesList = []
      this.vendornameitem = {
        value: '',
        text: ''
      }
      this.vendorname = ''
      this.vendornameLoading = ''
      this.vehiclenoitem = {
        value: '',
        text: ''
      }
      this.vehicleno = ''
      this.vehiclenoLoading = ''
      this.fromdate = ''
      this.todate = ''
      this.isLoading = false
      this.$validator.reset()
      this.cutoffdetails = []

    },
    onSubmitflt: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          this.getUnscheduledList();
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },

    //for schedule local trip
    openLocalTripModal() {
      var date = new Date()
      this.tripsheetnodate = moment(date).format('YYYY-MM-DD')
      let vehiclenoarr = this.vehicleno.trim().match(/.{0,2}/g);
      if (this.stateListData.length > 0 && !this.stateListData.includes(vehiclenoarr[0].toUpperCase())){
        this.$alertify.error('Error:  Invalid Vehicle Number');
        return false;
      }else{
      this.LocalTripModal = true
      }
      // this.getConnections(1)
    },
    closeLocalTripModal() {
      this.LocalTripModal = false
      this.vehicletypelist = [],
      this.vehicletypeitem = {
        value: '',
        text: ''
      },
      this.marketvendorname = '';
    },
    onSubmitLocalTrip: function(localtripTab) {
      this.$validator.validateAll('localtripTab').then((result) => {
        if (!result) {
          return false;
        } else {
          let vehiclenoarr = this.localvehicleno.trim().match(/.{0,2}/g);

          if (this.stateListData.length > 0 && !this.stateListData.includes(vehiclenoarr[0].toUpperCase())){
            this.$alertify.error('Error: Invaild Vehicle Number');
            return false;
          }
          if(this.isBikerTripEnabled){
            this.generateplacementIDforBiker();

          }else{
          this.GeneratePlacementID();
          }
        }
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
        console.log('errors exist', this.errors)
      });
    },
    getConnections(value) {
      this.connectionvalue=value
      if (value == 6) {
        this.getBikerVehicleNumerList()
      }
      this.RouteLoading = 'Loading Route Name...'
      var connectionData = []
      this.isVTRAFlag = false
      this.routelist = []
      this.input = buildConnectionsSearchPayload(CONNECTION_SEARCH_PURPOSE.LOCAL_TP, {
        type: value,
        source: this.hubid[0]
      })
      axios({
          method: 'POST',
          //url: apiUrl.api_url_hubops + 'getConnectionListForLocalTP', // getConnectionList
          url: getConnectionsSearchUrl(),
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.RouteLoading = ''
          if (result.data.ResultCode == 100) {
            connectionData = result.data.ResponseData
            this.isVTRAFlag = result.data.isVTRAFlag
            this.isAdhocEnable=result.data.IsAdhocEnable
            this.invalidTokenModal = false
            if (connectionData.length > 0) {
              this.RouteError = ''
              for (var i = 0; i < connectionData.length; i++) {
                this.routelist.push({
                  value: connectionData[i].ConnectionID,
                  text1: connectionData[i].ConnectionName,
                  text: connectionData[i].FullConnectionName,
                  actualroute: connectionData[i].FullConnectionName,
                  isBikerAllowed:connectionData[i].IsBikerAllowed
                })
              }
            } else {
              this.RouteError = "No Connection found"
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.RouteLoading = ''
          console.error(error)
        })
    },
    selectRoute(routeitem) {
      this.ResetLocalTripDetails();
      this.connectionID = routeitem.value
      this.routeitem = routeitem
      this.route = this.routeitem.text1
      this.actualroute = routeitem.actualroute;
      this.isBikerFlag = routeitem.isBikerAllowed;
      this.cutofflist = []
      this.cutoffitem = {
        value: '',
        text: '',
        name: '',
        date:''
      }
      this.cutoff = ''
      this.CutoffError = ''
      this.IsCutOffPresent = false
      if (this.routeitem.value != '' && this.triptypeitem.value!='') {
        // if (this.triptypeitem.value != 'market') {
          this.cutofflist = []
          this.cutoffitem = {
            value: '',
            text: '',
            name: '',
            date:''
          }
          this.cutoff = ''
          this.CutoffError = ''
          this.IsCutOffPresent = false
          this.$validator.reset()
          this.getCutOffList()
        // }
        // else {
        //   this.cutoffitem = {
        //     value: null,
        //     text: 'Unscheduled',
        //     name: 'Unscheduled',
        //     date:'Unscheduled'
        //   }
        //   this.cutoff = 'Unscheduled'
        //   this.CutoffError = ''
        //   this.IsCutOffPresent = false
        //   this.cutofflist = [{
        //     value: null,
        //     text: "Unscheduled",
        //     name: "Unscheduled",
        //     date:"Unscheduled"
        //   }]
        //   this.$validator.reset()
        // }
      }
    },
    selectTripType(triptypeitem) {
      this.triptypeitem = triptypeitem
      this.triptype = triptypeitem.text
      this.triptypevalue=triptypeitem.value
      this.localvendoritem = {
        value: '',
        text: ''
      }
      this.localvendorlist = []
      this.localvendor = ''
      this.localvehiclenoitem = {
        value: '',
        text: '',
        isGPS: '',
        GPScompany: ''
      }
      this.localvehicleno = ''
      this.localvehiclenolist = []
      this.$validator.reset()
      this.getLocalVendorList()
      if (this.localvendor != '' && this.triptype != '') {
        this.getLocalVehicleNo()
      }
      if(this.triptypevalue==='local')
        this.triptypevalue='regular'
      if (this.routeitem.value != '') {
        // if (this.triptypeitem.value != 'market') {
          this.cutofflist = []
          this.cutoffitem = {
            value: '',
            text: '',
            name: '',
            date:''
          }
          this.cutoff = ''
          this.CutoffError = ''
          this.IsCutOffPresent = false
           // Hub: 7244: VTRA
           if (
            this.triptypeitem.value == 'market' ||(this.triptypeitem.value == 'local' && !this.isVTRAFlag)) {
            this.getCutOffList();
          }
        // }
        // else {
        //   this.cutoffitem = {
        //     value: null,
        //     text: 'Unscheduled',
        //     name: 'Unscheduled',
        //     date:'Unscheduled'
        //   }
        //   this.cutoff = 'Unscheduled'
        //   this.CutoffError = ''
        //   this.IsCutOffPresent = false
        //   this.cutofflist = [{
        //     value: null,
        //     text: "Unscheduled",
        //     name: "Unscheduled",
        //     date:'Unscheduled'
        //   }]
        // }
      }
      this.vehicletypeloader = '';
      this.vehicletypelist = []
      this.vehicletypeitem = {
        value: '',
        text: ''
      }
      this.marketvendorname = '';
      if(this.triptypeitem.value == "market"){
         if (!this.isAdhocEnable) {
       this.getVehicleTypeforMarket();
         } else {
       this.getAdhocVendorList();
       }
      }
    },

    generateplacementIDforBiker(){
      if (this.isBikerTripEnabled) {
        var re = /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/;
        if (re.test(this.localvehicleno) == false) {
          this.isLoading = false;
          this.validVehicleNoError = true;
          return false;
        } else {
          this.validVehicleNoError = false;
        }
      }
      this.isLoading = true;
      var date = new Date()
      var placementdate = moment(date).format('YYYY-MM-DD')
      if(this.isBikerTripEnabled){
        this.input = {
            "hubid": this.hubid[0],
            "hubname":this.hubdata.HubName,
            "hubaddress": this.hubdata.HubAddress,
            "vehicleplacementdate": placementdate,
            "connectionid": this.routeitem.value,
            "connectionname": this.routeitem.text1,
            "drivername":this.srName,
            "srusername":this.srName,
            "sruserid": this.srId,
            "vehiclenumber": this.localvehicleno,
            "type": "biker",
            "cutoffid" :this.cutoffitem.value,
            "cutoffdate":this.cutoffitem.date ,
            "cutoffname":this.cutoffitem.name,
            "triptype":"network-local",
            "status":"placed",
            "createdby":this.useremail
        }
        axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'saveBikerPlacementVehicle_tms',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.localplacementid = result.data.ResponseData.placementid
            this.scheduleLocalBikerTrip()
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    }
    
  },
    getLocalVendorList() {
      this.LocalVendorLoading = 'Loading Vendor Name...'
      var VendorNameData = []
      this.localvendorlist = []
      // Hub: 7244: VTRA
      if (this.triptypeitem.value == 'local' && this.isVTRAFlag) {
        this.input = {
          HubId: this.hubid[0],
          VendorType: this.triptypeitem.value,
          connectionId: this.connectionID
        }
      } else {
        this.input = {
          HubId: this.hubid[0],
          VendorType: this.triptypeitem.value,
        }
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getvendorlistforlocalplacement',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.LocalVendorLoading = ''
          if (result.data.ResultCode == 100) {
            var VendorNameData = result.data.ResponseData;
            for (var i = 0; i < VendorNameData.length; i++) {
              this.localvendorlist.push({
                value: VendorNameData[i].VehicleVendorCompanyID,
                text: VendorNameData[i].VehicleVendorCompanyName,
                email: VendorNameData[i].VehicleVendorEmailId
              })
            }
            if(this.triptypeitem.value == 'market'){
              this.localvendoritem.value = this.localvendorlist[0].value;
              this.localvendor = this.localvendorlist[0].text;
              this.localvendoritem.text = this.localvendor;
            }
          } else {
            VendorNameData = []
            this.localvendorlist = []
            this.$alertify.error(result.data.ReturnMessage)
          }

        }, error => {
          this.LocalVendorLoading = ''
          console.error(error)
        })
    },
    selectVendor(localvendoritem) {
      this.localvendoritem = localvendoritem
      this.localvendor = localvendoritem.text
      this.localvehiclenoitem = {
        value: '',
        text: '',
        isGPS: '',
        GPScompany: ''
      }
      this.localvehicleno = ''
      this.VehicleError = ''
      this.localvehiclenolist = []
      this.$validator.reset()
      // Hub: 7244: VTRA
      if (this.triptypeitem.value == "local" && this.isVTRAFlag) {
        this.vehicletypelist = [],
          this.vehicletypeitem = {
            value: '',
            text: ''
          },
          this.cutofflist = []
          this.cutoffitem = {
          value: '',
          text: '',
          name: '',
          date: ''
        }
        this.cutoff = ''
        this.CutoffError = '';
        this.getVehicleTypeforMarket()
      } else {
        if (this.localvendor != '' && this.triptype != '') {
          this.getLocalVehicleNo()
        }
      }
    },
    getLocalVehicleNo() {
      if(!this.localvendoritem.value){
        return false
      }
      this.LocalVehicleNoLoading = 'Loading Vehicle Number...'
      var VehicleNoData = []
      this.localvehiclenolist = []
      this.VehicleError = ''
      this.input = {
        hubid: this.hubid[0],
        vehiclevendorcompanyid: this.localvendoritem.value,
        vendortype: this.triptypeitem.value
      }
      // Hub: 7244: VTRA
      if (this.triptypeitem.value == 'local' && this.isVTRAFlag) {
        this.input.connectionid = this.connectionID;
        this.input.vehicletypeid = this.VehicleId;
      }

      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'localvehiclenumberlist',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.LocalVehicleNoLoading = ''
          if (result.data.ResultCode == 100) {
            var VehicleNoData = result.data.ResponseData;
            this.VehicleError = ''
            var localvehiclenolist = []
            for (var i = 0; i < VehicleNoData.length; i++) {
              localvehiclenolist.push({
                text: VehicleNoData[i].VehicleNumber,
                isGPS: VehicleNoData[i].IsGPSEnabled,
                GPScompany: VehicleNoData[i].GPSCompanyName,
                vehiclevendorid: VehicleNoData[i].VehicleVendorId,
                vehicletype: VehicleNoData[i].VehicleType
              })
            }
            this.localvehiclenolist = localvehiclenolist.reduce((unique, o) => {
              if (!unique.some(obj => obj.text === o.text)) {
                unique.push(o);
              }
              return unique;
            }, []);
          } else {
            VehicleNoData = []
            localvehiclenolist = []
            this.localvehiclenolist = []
            this.VehicleError = result.data.ReturnMessage
          }
        }, error => {
          this.LocalVehicleNoLoading = ''
          this.$alertify.error("Vehicle API Error")
          console.error(error)
        })
    },
    selectVehicleNo(localvehiclenoitem) {
      this.localvehiclenoitem = localvehiclenoitem
      this.localvehicleno = localvehiclenoitem.text

      // Adhoc Vehicle
      if(this.triptypeitem.value == 'market' && this.isAdhocEnable){
        this.vehicletypelist = [];
        this.vehicletypeitem = {};
        this.vehicletype = '';
        if (localvehiclenoitem.value) {
          this.vehicletypeitem = {
            value: localvehiclenoitem.raw.VehicleTypeId,
            text: localvehiclenoitem.raw.VehicleTypeName
          }
          this.vehicletype=localvehiclenoitem.raw.VehicleTypeName
           this.localvendoritem = {
              value: localvehiclenoitem.raw.VehicleVendorId,
              text: localvehiclenoitem.raw.VendorName
             };   
        }else{
          return;
        }
      }

      this.getVehicleDetails()
    },
    getVehicleDetails() {
      var VendorNameData = []
      this.VehicleDetails = []
      if (this.trip == 'linehaulbiker') {
        this.input = {
          vehicleid: this.bikervehicleitem.vehicleid,
        }
      } 
      if (this.triptypeitem.value == 'local' && this.isVTRAFlag) {
        this.input = {
          vehicleid: this.localvehiclenoitem.vehicletype[0],
          vendorid: this.localvendoritem.value,
          connectionid: this.connectionID
        }
      }else {
          if( this.triptypeitem.value == 'market' && this.isAdhocEnable){
             this.input = {
          vehicleid: this.localvehiclenoitem.raw.VehicleTypeId,
        }
          }
         else  {this.input = {
          vehicleid: this.localvehiclenoitem.vehicletype[0],
        }}
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getVehicleDetails',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.VehicleDetails = result.data.ResponseData;
          } else {
            this.VehicleDetails = []
          }
        }, error => {
          console.error(error)
        })
    },
    selectReason(reasonitem) {
      this.reasonitem = reasonitem
      this.reason = reasonitem.text
    },
    GeneratePlacementID() {
      this.isLoading = true;
      var date = new Date()
      var placementdate = moment(date).format('YYYY-MM-DD')
      if (this.trip == 'linehaulbiker') {
        this.input = {
          "vehiclevendorcompanyid": this.bikeritem.value,
          "vendorname": this.bikeritem.text,
          "vehiclevendoremail": this.useremail,
          "hubid": this.hubid[0],
          "hubname": this.hubdata.HubName,
          "hubaddress": this.hubdata.HubAddress,
          "vehicleplacementdate": placementdate,
          "connectionid": this.routeitem.value,
          "connectionname": this.routeitem.text1,
          "vehiclename": this.VehicleDetails[0].VehicleName,
          "vehicleid": this.VehicleDetails[0].VehicleId,
          "vehiclenumber": this.bikervehicleitem.value,
          "drivername": this.bikeritem.text,
          "phonenumber": this.bikeritem.mobileno,
          "status": "placed",
          "type": 'linehaulbiker',
          "isgpsenabled": 0,
          "gpscompanyname": '',
          "vehiclevendorid": 0
        }
      } else {
         let isgpsenabled =this.localvehiclenoitem && this.localvehiclenoitem.isGPS  ? this.localvehiclenoitem.isGPS : 0
         let gpscompanyname = this.localvehiclenoitem && this.localvehiclenoitem.GPScompany ? this.localvehiclenoitem.GPScompany: ''
         let vehiclevenderid =this.localvehiclenoitem && this.localvehiclenoitem.vehiclevendorid != null ? this.localvehiclenoitem.vehiclevendorid: 0
        if (this.triptypeitem.value == 'market') {
          var re = /^([A-Z|a-z]{2}\s{1}[0-9]{1,2}\s{1}[A-Z|a-z]{1,3}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,2}[A-Z|a-z]{1}\s{1}[A-Z|a-z]{2}\s{1}\d{4})?([A-Z|a-z]{3}\s{1}\d{3})?([A-Z|a-z]{2}\s{1}[0-9]{2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,3}\s{1}[A-Z|a-z]{1}\s{1}\d{3,4})?$/;
          if (re.test(this.localvehicleno) == false) {
            this.isLoading = false;
            this.validVehicleNoError = true;
            return false;
          } else {
            this.validVehicleNoError = false;
          }
          // var VehicleName = "32 FT Single Axel (9-MT)"
          // var VehicleId = 37
          var VehicleName = this.VehicleName
          var VehicleId = this.VehicleId
         
          //VehicleDetails according to featureflag
          if(this.isAdhocEnable){
          var VehicleName = this.VehicleDetails[0].VehicleName
          var VehicleId = this.VehicleDetails[0].VehicleId
          isgpsenabled = this.localvehiclenoitem.raw && this.localvehiclenoitem.raw.IsGPSEnabled ? this.localvehiclenoitem.raw.IsGPSEnabled : 0
          gpscompanyname= this.localvehiclenoitem.raw &&this.localvehiclenoitem.raw.GPSCompanyName? this.localvehiclenoitem.raw.GPSCompanyName: ''
          vehiclevenderid = this.localvehiclenoitem.raw && this.localvehiclenoitem.raw.VehicleVendorId != null? this.localvehiclenoitem.raw.VehicleVendorId: 0
          }
        } else {
          var VehicleName = this.VehicleDetails[0].VehicleName
          var VehicleId = this.VehicleDetails[0].VehicleId
        }
        this.input = {
          "vehiclevendorcompanyid": this.localvendoritem.value,
          "vendorname": this.localvendoritem.text,
          "vehiclevendoremail": this.useremail,
          "hubid": this.hubid[0],
          "hubname": this.hubdata.HubName,
          "hubaddress": this.hubdata.HubAddress,
          "vehicleplacementdate": placementdate,
          "connectionid": this.routeitem.value,
          "connectionname": this.routeitem.text1,
          "vehiclename": VehicleName,
          "vehicleid": VehicleId,
          "vehiclenumber": this.localvehicleno,
          "drivername": this.drivername,
          "phonenumber": this.drivercontactno,
          "status": "placed",
          "type": this.triptypevalue,
          "isgpsenabled": isgpsenabled,
          "gpscompanyname": gpscompanyname,
          "vehiclevendorid": vehiclevenderid,
          "marketvendorname":this.marketvendorname,
          "triptype":'network-local'
        };

      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'savelocalplacementdetails',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.localplacementid = result.data.ResponseData.placementid
            this.scheduleLocalBikerTrip()
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    scheduleLocalBikerTrip() {
      this.input =({
        "currentHubId": this.hubid[0],
        "placementId": this.localplacementid,
        "connectionName": this.routeitem.text1,
        "fullConnectionName": this.actualroute,
        "connectionId": this.routeitem.value,
        "hubCode": this.hubdata.HubCode,
        "hubName": this.hubdata.HubName,
        "createdBy": this.useremail

    })

      if (this.trip == 'linehaulbiker') {
        Object.assign(this.input,{
          
          "vehicleNo": this.bikervehicleitem.value,
          "connectionId": this.routeitem.value,
          "vendorId": this.bikeritem.value,
          "vendorName": this.bikeritem.text,
          "hubCode": this.hubdata.HubCode,
          "hubName": this.hubdata.HubName,
          "driverDetails": [{
            "DriverName": this.bikeritem.text,
            "Mobile": this.bikeritem.mobileno
          }],
          "createdBy": this.useremail,
          "vendorType": "biker",
          "connectionType": 6,
          "isBikerTrip": false
        })
      } else {
        if(this.isBikerTripEnabled){
          Object.assign( this.input ,{
         
         "vehicleNo": this.localvehicleno,
         "vendorId": this.srId,
         "vendorName": null,
         "driverDetails": [{
           "Mobile": null,
           "DriverName":this.srName
         }],
         "vendorType": null,
         "connectionType": 4,
         "scheduleCutOff": this.cutoffitem.text,
         "scheduleCutOffId": this.cutoffitem.value,
         "isCutOffPresent": this.IsCutOffPresent,
         "CutOffDate":this.cutoffitem.date,
         "isBikerTrip": true
       })
      }else{
        Object.assign(this.input, {
          "vehicleNo": this.localvehicleno,
          "vendorId": this.localvendoritem.value,
          "vendorName": this.localvendoritem.text,
          "driverDetails": [{
            "DriverName": this.drivername,
            "Mobile": this.drivercontactno
          }],
          "vendorType": this.triptypeitem.value,
          "connectionType": 4,
          "scheduleCutOff": this.cutoffitem.text,
          "scheduleCutOffId": this.cutoffitem.value,
          "isCutOffPresent": this.IsCutOffPresent,
          "CutOffDate":this.cutoffitem.date,
          "isBikerTrip": false
        })

      }
       
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'tripConnectionScheduleMaster',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.TripConnectionScheduleResult = result.data.ResponseData
            if (this.trip == 'linehaulbiker') {
              this.scheduleDeatilsList.push({
                "thcno": result.data.ResponseData.TripID,
                "tripid": result.data.ResponseData.TripID,
                "connectionschedulemasterid": result.data.ResponseData.ConnectionScheduleMasterId,
                "fullconnectionname": this.routeitem.text1,
                "vehicleno": this.bikervehicleitem.value,
                "vehiclename": this.VehicleDetails[0].VehicleName,
                "vendorname": this.bikeritem.text,
                "invoiceno": result.data.ResponseData.InvoiceNo,
                "vendorid": this.bikeritem.value,
                "connectionid": this.routeitem.value,
                "routemode": "Surface",
                "triptype": "linehaulbiker"
              })
            }
            else if(this.isBikerTripEnabled){
              this.scheduleDeatilsList.push({
              "thcno": result.data.ResponseData.TripID,
              "tripid": result.data.ResponseData.TripID,
              "connectionschedulemasterid": result.data.ResponseData.ConnectionScheduleMasterId,
              "fullconnectionname": this.routeitem.actualroute,
              "vehicleno": this.localvehicleno,
              "vehiclename": "Biker",
              "vendorname": "",
              "invoiceno": result.data.ResponseData.InvoiceNo,
              "vendorid": this.srId,
              "connectionid": this.routeitem.value,
              "routemode": "Surface",
              "triptype": "network-local",
              "isbikertrip":true
         })
            }else{
              if (this.triptypeitem.value == 'market') {
                var VehicleName = this.VehicleName
                if(this.isAdhocEnable){
                var VehicleName = this.vehicletype
                }
              } else {
                var VehicleName = this.VehicleDetails[0].VehicleName
              }
              this.scheduleDeatilsList.push({
                "thcno": result.data.ResponseData.TripID,
                "tripid": result.data.ResponseData.TripID,
                "connectionschedulemasterid": result.data.ResponseData.ConnectionScheduleMasterId,
                "fullconnectionname": this.routeitem.actualroute,
                "vehicleno": this.localvehicleno,
                "vehiclename": VehicleName,
                "vendorname": this.localvendoritem.text,
                "invoiceno": result.data.ResponseData.InvoiceNo,
                "vendorid": this.localvendoritem.value,
                "connectionid": this.routeitem.value,
                "routemode": "Surface",
                "triptype": "network-local"
              })
            }
            this.$alertify.success(result.data.ReturnMessage);
            this.goToGenerateTripSheetPage()
            this.LocalTripModal = false
            this.ResetLocalTripDetails()
            this.ResetBikerTripDetails()
            this.trip = ''
            this.tripErr = ''
          }
         else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
          user_tracker.checkUserIP(this.userData[0], "ScheduleLocal-TP or linehaulbiker Trip", this.$route.path,this.input)
        }, error => {
          console.error(error)
        })
    },
    goToGenerateTripSheetPage() {
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getVehicleCapacityforSchedule?ConnectionScheduleMasterId=' + this.TripConnectionScheduleResult.ConnectionScheduleMasterId + '&TripID=' + this.TripConnectionScheduleResult.TripID + '&CurrentHubId=' + this.hubid[0] + '&vehicleType=' + this.vehicleType,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            var VehicleCapacityData = result.data.ResponseData
            let routeData = this.$router.replace({
              path: "GenerateTripSheet",
              query: {
                scheduleData: this.scheduleDeatilsList[0],
                VehicleCapacityData: VehicleCapacityData
              }
            })
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    getCutOffList() {
      // Hub: 7244: VTRA
      var cutofflist = []
      this.cutofflist = []
      this.cutoffitem = {
        value: '',
        text: '',
        name: '',
        date: ''
      }
      this.cutoff = ''
      this.CutoffError = '';
      //
      this.input = {
        "connectionId": parseInt(this.routeitem.value),
        "hubId": this.hubid[0],
        "connectionType": 4,
        "tripType":this.triptypevalue
      }
      // Hub: 7244: VTRA
      if (this.triptypeitem.value == 'local' && this.isVTRAFlag) {
        this.input.vendorid = this.localvendoritem.value;
        this.input.vehicletypeid = this.VehicleId;
      }
      if(this.isBikerTripEnabled){
        this.input.tripType = "biker";
      }else{
        this.input.tripType = this.triptypevalue;
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "getCutOff",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.CutoffError = ''
            cutofflist = result.data.ResponseData;
            this.IsCutOffPresent = result.data.IsCutOffPresent
            for (var i = 0; i < cutofflist.length; i++) {
              this.cutofflist.push({
                value: cutofflist[i].CutoffID,
                text: cutofflist[i].CutOffTime,
                name: cutofflist[i].CutoffName,
                date:cutofflist[i].CutOffDate
              })
            }
            // if(this.IsCutOffPresent==false)
            if (this.cutofflist.length == 1) {
              for (var i = 0; i < this.cutofflist.length; i++) {
                this.cutoffitem = {
                  value: this.cutofflist[i].value,
                  text: this.cutofflist[i].text,
                  name: this.cutofflist[i].name,
                  date:this.cutofflist[i].date
                }
                this.cutoff = this.cutofflist[i].text
              }
            } else {
              this.cutoffitem = {
                value: '',
                text: '',
                name: '',
                date:''
              }
              this.cutoff = ''
            }
          } else {
            this.CutoffError = result.data.ReturnMessage
            this.IsCutOffPresent = false
            cutofflist = []
            //this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.$alertify.error("API Error")
          console.error(error)
        })
    },
    selectedCutoff(cutoffitem) {
      this.cutoffitem = cutoffitem
      this.cutoff = cutoffitem.text
    },
    ResetLocalTripDetails() {
      this.tripsheetno = ''
      var date = new Date()
      this.tripsheetnodate = moment(date).format('YYYY-MM-DD')
      this.routeitem = {
        value: '',
        text: '',
        actualroute: ''
      }
      this.route = ''
      this.RouteError = ''
      this.RouteLoading = ''
      this.actualroute = ''
      this.triptypeitem = {
        value: '',
        text: ''
      }
      this.triptype = ''
      this.localvendoritem = {
        value: '',
        text: '',
        email:''
      }
      this.localvendor = ''
      this.LocalVendorLoading = ''
      this.localvehiclenoitem = {
        value: '',
        text: ''
      }
      this.localvehicleno = ''
      this.LocalVehicleNoLoading = ''
      this.openkm = ''
      this.drivername = ''
      this.drivercontactno = ''
      this.amount = ''
      this.VehicleError = ''
      this.reasonitem = {
        value: '',
        text: ''
      }
      this.reason = ''
      this.cutoffitem = {
        value: '',
        text: '',
        name: ''
      }
      this.cutoff = ''
      this.CutoffError = ''
      this.IsCutOffPresent = false,
      this.$validator.reset()
      this.validVehicleNoError = false;
      this.vehicletype = ''
      this.vehicletypeitem = {
       value: '',
       text: ''
     }
     this.vehicletypeloader = '';
     this.marketvendorname = '';
     this.isBikerTripEnabled = false;
     this.srData =[];
     this.vehicleType ='';
     this.srListForAllocatedParentCity =[];
     this.isBikerFlag=false;
     this.bikertrip =false;
     this.sr= '';
     //  this.isAdhocEnable = false;
     this.adhocvendorlist=[],
      this.adhocvendoritem= {
        value: '',
        text: ''
      },
      this.adhocvendor= ''

    },
    // for Linehaul Biker
    getBikerVehicleNumerList() {
      this.BikerVehicleNumberLoading = 'Loading Biker Vehicle Number...'
      var BikerVehicleNumberData = []
      this.bikervehiclelist = []
      this.input = {
        hubId: this.hubid[0],
        vendorType: "biker"
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'getLineHaulBikersListByHubId',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.BikerVehicleNumberLoading = ''
          if (result.data.ResultCode == 100) {
            var BikerVehicleNumberData = result.data.ResponseData;
            for (var i = 0; i < BikerVehicleNumberData.length; i++) {
              this.bikervehiclelist.push({
                value: BikerVehicleNumberData[i].VehicleNumber,
                text: BikerVehicleNumberData[i].VehicleNumber,
                vehicleid: BikerVehicleNumberData[i].VehicleType
              })
            }
          } else {
            BikerVehicleNumberData = []
            this.bikervehiclelist = []
            this.$alertify.error(result.data.ReturnMessage)
          }

        }, error => {
          this.BikerVehicleNumberLoading = ''
          console.error(error)
        })
    },
    selectBikerVehicleNumber(bikervehicleitem) {
      this.bikervehicleitem = bikervehicleitem
      this.bikervehiclenumber = bikervehicleitem.text
      this.getBikerDetails()
      this.getVehicleDetails()
    },
    getBikerDetails() {
      this.BikerNameLoading = 'Loading Biker Vehicle Number...'
      var BikerData = []
      this.bikerlist = []
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getLineHaulBikerDetailsByBikeNo?vehicleNo=' + this.bikervehiclenumber,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.BikerNameLoading = ''
          if (result.data.ResultCode == 100) {
            var BikerData = result.data.ResponseData;
            for (var i = 0; i < BikerData.length; i++) {
              this.bikerlist.push({
                value: BikerData[i].BikerVendorId,
                text: BikerData[i].BikerName,
                mobileno: BikerData[i].BikerMobileNo,
                vehicleno: BikerData[i].VehicleNumber,
              })
            }
          } else {
            BikerData = []
            this.bikerlist = []
            this.$alertify.error(result.data.ReturnMessage)
          }

        }, error => {
          this.BikerNameLoading = ''
          console.error(error)
        })
    },
    selectBikerName(bikeritem) {
      this.bikeritem = bikeritem
      this.bikername = bikeritem.text
    },
    onSubmitLinehaulBikerTrip: function(bikertripTab) {
      this.$validator.validateAll('bikertripTab').then((result) => {
        if (!result) {
          return false;
        } else {
          this.GeneratePlacementID()
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

    getVehicleTypeforMarket() {
      // Hub: 7244: VTRA
      if (this.triptypeitem.value == 'local' && this.isVTRAFlag) {
        this.input = {
          vendorid: this.localvendoritem.value,
          connectionId: this.connectionID
        };
      } else {
        this.input = {}
      }
      this.vehicletypeloader = 'Loading Vehicle Type...'
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getVehicleTypeforMarketHired',
          params: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          let VehicleTypeDetails = result.data.ResponseData;
          for (var i = 0; i < VehicleTypeDetails.length; i++) {
            this.vehicletypelist.push({
              "value": VehicleTypeDetails[i].VehicleId,
              "text": VehicleTypeDetails[i].VehicleName
            })
          }
          this.vehicletypeloader = '';
        }, error => {
          this.vehicletypeloader = '';
          console.error(error)
        })
    },
    selectvehicletype(vehicletypeitem){
      this.vehicletype = vehicletypeitem.value
      this.vehicletypeitem = {
        value: '',
        text: ''
      }
      this.VehicleId = vehicletypeitem.value;
      this.VehicleName = vehicletypeitem.text;
      this.vehicletypeitem = vehicletypeitem;
      // Hub: 7244: VTRA
      if (this.triptypeitem.value == 'local' && this.isVTRAFlag) {
        this.localvehiclenoitem = {
          value: '',
          text: '',
          isGPS: '',
          GPScompany: ''
        }
        this.localvehicleno = '',
          this.localvehiclenolist = [],
          this.VehicleError = '',
          this.getLocalVehicleNo()
        this.getCutOffList()
      }
    },

    ResetBikerTripDetails() {
      this.tripsheetno = ''
      var date = new Date()
      this.tripsheetnodate = moment(date).format('YYYY-MM-DD')
      this.routeitem = {
        value: '',
        text: '',
        actualroute: '',
        isBikerAllowed:''
      }
      this.route = ''
      this.RouteError = ''
      this.RouteLoading = ''
      this.actualroute = ''
      this.bikervehicleitem = {
        value: '',
        text: '',
        vehicleid: ''
      }
      this.bikervehiclenumber = ''
      this.BikerVehicleNumberLoading = ''
      this.bikeritem = {
          value: '',
          text: '',
          mobileno: '',
          vehicleno: ''
        },
        this.bikername = '',
        this.BikerNameLoading = '',
        this.openkm = ''
        this.$validator.reset(),
        this.vehicletypelist = [],
        this.vehicletypeitem = {
        value: '',
        text: ''
       }
    },
    selectAdhocVendor(adhocvendoritem) {
       this.localvehiclenolist=[];
      this.localvehiclenoitem={};
      this.localvehicleno='';
      this.vehicletypelist = [],
      this.vehicletypeitem = {}
      this.vehicletype = ''

     if (!adhocvendoritem || !adhocvendoritem.value) {
        this.adhocvendoritem={}
        this.adhocvendor=''
      
        this.LocalVehicleNoLoading = ''

        return
      }
     
      this.adhocvendoritem = adhocvendoritem
      this.adhocvendor = adhocvendoritem.text
      this.getAdhocVehiclesMiddleMile(this.adhocvendoritem.value)
    },
    getAdhocVendorList(){
    this.LocalVendorLoading = 'Loading Vendor Name...'
    this.vehicletypelist = []
    this.input={
    "HubId":this.hubid[0],
    "ConnectionId":this.connectionID,
    "VendorType":"local"
    }
     axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'GetAdhocVendorDetails',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        }).then(result => {
          this.LocalVendorLoading = ''
          if (result.data.ResultCode == 100) 
            {
            this.adhocvendorlist = result.data.ResponseData.map(v => ({
            value: v.VehicleVendorId,
            text: v.VehicleVendorCompanyName
         }));
          }else{
            this.$alertify.error(result.data.ReturnMessage)
          }

           }) ,error => {
          this.LocalVendorLoading = ''
          console.error(error)
        }
  },

  getAdhocVehiclesMiddleMile(VehicleVendorId){
    this.LocalVehicleNoLoading = 'Loading Vehicle Number...'
    this.input={
    "HubId":this.hubid[0],
    "ConnectionId":this.connectionID,
    "VendorType":"local",
    "VehicleVendorId" :VehicleVendorId
    }
     axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'GetAdhocVehiclesMiddleMile',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        }).then(result => {
          this.LocalVehicleNoLoading = ''
          if (result.data.ResultCode == 100) 
            {
            this.localvehiclenolist = result.data.data.map(v => ({
               value: v.VehicleVendorId,
               text: v.VehicleNumber,
               raw: v 
            }));
          }
          else{
            this.$alertify.error(result.data.ReturnMessage)
          }
           }),error => {
          this.LocalVehicleNoLoading = ''
          console.error(error)
        }
  }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/NetworkManagement/UnScheduledList/UnScheduledList.js